/* eslint-disable */
function expand_menu_children() {
  $(".main-menu-container li.menu-item-has-children span.extract").on(
    "click",
    function() {

      var parentid = $(this).closest('li');
      parentid.toggleClass('expanded');
      //($(this).closest('li').attr('class'));
      parentid.find('.sub-menu').slideToggle( "fast", function() {
        // Animation complete.
      });

    }
  );
}

$('#mobilemenu-overlay').on('click', function() {
  $('#menu-btn').prop("checked", !$('#menu-btn').prop("checked"));
  $('#mobilemenu-overlay').hide();
});

function add_item_span() {
  $(".main-menu-container li.menu-item-has-children").each(function() {
    $(this).append('<span class="extract"></span>');
  });
}

$("#menu-btn").on('change', function() {
  if(this.checked) {
    $('#mobilemenu-overlay').show();
  }
  else {
    $('#mobilemenu-overlay').hide();
  }
});

add_item_span();
expand_menu_children();





/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/autoload/menus.js